<template>
  <div>
    <div id="print-div" class="only-print">
      <div class="vertical-height-div" style="height: 65px"></div>
      <qrcode
        class="pass-qrcode"
        :value="ticket.qrcode"
        :options="{ width: 100 }"
        tag="img"
      ></qrcode>
      <div class="vertical-height-div" style="height: 271px"></div>
      <div class="printed-pass-name">{{ ticket.firstName }}</div>
      <div class="printed-pass-surname">{{ ticket.lastName }}</div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    ticketId: {
      type: [Number, String],
    },
    ticket: {
      type: [Object],
    },
    printTrigger: {
      type: Number,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      lang: (state) => state.lang,
      user: (state) => state.auth.user,
    }),
    project() {
      return this.$store.getters["projects/get"](this.projectId);
    },
    work() {
      return this.$store.getters["works/get"](this.workSelected);
    },
  },
  watch: {
    printTrigger() {
      this.print();
    },
  },
  components: {},
  methods: {
    print() {
      const html = document.getElementById("print-div").cloneNode(true);

      // Get all stylesheets HTML
      const headElements = [],
        inserted = [];
      for (const node of [
        ...document.querySelectorAll('link[href$=".css"], style'),
      ]) {
        // stylesHtml += node.innerHTML;
        if (node.tagName === "STYLE") {
          const elem = document.createElement("style");
          elem.type = "text/css";
          elem.innerHTML = node.innerHTML;
          headElements.push(elem);
        } else {
          if (!inserted.find((s) => s === node.href)) {
            inserted.push(node.href);
            const elem = document.createElement("link");
            elem.type = "text/css";
            elem.rel = "stylesheet";
            elem.href = node.href;
            headElements.push(elem);
          }
        }
      }
      this.$anm22.print(html, headElements);
      this.$emit("closePrintDialog");
    },
  },
};
</script>

<style lang="scss" scoped>
.print-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 24px;
  height: 24px;
  cursor: pointer;
}
.only-print {
  display: none !important;
}
@page {
  margin: 0cm !important;
}
@media print {
  html,
  body {
    background-color: #fff;
    -webkit-print-color-adjust: exact;
  }
  #print-div {
    background-color: #fff;
  }
  .only-print {
    display: block !important;
  }
  .print-break-after {
    break-after: page;
  }
  // .print-elem[type="text"] {
  //   // &[type="text"] {
  //     border-radius: 0;
  //     border: none;
  //     border-bottom: 1px solid #bbb;
  //   // }
  // }
}
</style>
<style lang="scss">
@media print {
  html,
  body {
    background-color: #fff;
    -webkit-print-color-adjust: exact;
  }
  .print-text {
    font-size: 10px !important;
    overflow: hidden;
  }
  .print-div {
    padding: 50px 0 0 0;
    width: 100%;
    height: 100%;
    height: 100vh;
    background-color: #fff;
    padding-left: 170px;
    position: relative;
  }
  .pass-qrcode {
    position: absolute;
    top: 70px;
    left: 55px;
  }
  .printed-pass-name,
  .printed-pass-surname {
    position: absolute;
    left: 10px;
    font-size: 16px;
    width: 200px;
    text-align: center;
    -webkit-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    transform: rotate(180deg);
  }
  .printed-pass-name {
    top: 40px;
  }
  .printed-pass-surname {
    top: 9px;
  }
}
</style>
